import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';

import { ReportService } from '@services/index';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [CommonModule, MatIconModule],
})

export class BreadcrumbComponent {
  public breadcrumbs$: Observable<string[]> = this.reportService.breadcrumbs$;
  public activeBreadcrumb$: Observable<string> =this.reportService.activeBreadcrumb$

  constructor(private reportService: ReportService) {}

  onBreadcrumbClick(title: string): void {
    this.reportService.updateBreadcrumbs(title, true);
  }
}
